export const GET_MY_INTEGRATIONS_QUERY_KEY = ['my-integrations'] as const;
